
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomathereinnova() {



    const cardData =
    {
        keyword: 'Pune to Matheran Innova Crysta Cab Booking',
        heading: 'Meghana Cab : Pune to Matheran Innova Crysta Cab Booking',
        headingDescription: 'Meghana Cab offers Pune to Matheran Innova Crysta Cab Booking, providing a luxurious, comfortable, and scenic getaway just 120–124 km from Pune via the Mumbai–Pune Expressway, with a drive time of approximately 2½–3 hours . Our spacious Innova Crysta vehicles feature plush leather interiors, ample legroom, generous luggage capacity, and full air-conditioning—ideal for family trips, romantic retreats, or relaxing solo escapes. Enjoy door-to-door pickup from anywhere in Pune, professional chauffeurs familiar with the route to Dasturi Car Point (where you park before taking the eco-friendly walk/rickshaw to the hill station), GPS-enabled vehicles, and flexible booking options (one-way, round-trip, or hourly). Backed by 24/7 customer support and transparent booking, Meghana Cab ensures your Pune to Matheran Innova Crysta journey is smooth, stylish, and tailored to create memorable moments amid nature’s serenity.',


        top: ' Top Places to Visit in Matheran with Meghana Cab',

"topPlaces": [
  {
    "title": "Louisa Point",
    "description": "Perched at the edge of the plateau, Louisa Point offers sweeping views of Prabal Fort, Vishalgad, and the valleys below—spectacular during sunrise, sunset, and misty monsoons."
  },
  {
    "title": "Charlotte Lake & Pisharnath Temple",
    "description": "This scenic 50 ft-deep seasonal lake is perfect for bird-watching and picnics. Adjacent to it, the 250‑year‑old Pisharnath Mahadev Temple offers lakeside serenity and cultural charm."
  },
  {
    "title": "Panorama Point & One Tree Hill",
    "description": "Two of the most famous lookout spots—Panorama Point gives a 360° vista of the Western Ghats, while One Tree Hill stands as a striking outcrop ideal for photography and quiet contemplation."
  },
  {
    "title": "Echo Point & Porcupine Point",
    "description": "At Echo Point your voice bounces off the deep valley, while Porcupine Point’s dramatic cliff edges offer unforgettable sunsets and sweeping hillside panoramas."
  },
  {
    "title": "Neral–Matheran Toy Train",
    "description": "A charming hour‑long heritage ride through tunnels, curves, and forests—Asia’s only UNESCO‑tentative hill railway that brings you into Matheran’s heart without harming its eco‑sensitive slopes."
  },
  {
    "title": "Dodhani Waterfalls & Chanderi Caves",
    "description": "Adventure seekers can rappel down Dodhani Falls and explore Chanderi’s rock‑cut caves via scenic forest treks—two contrasting yet thrilling trails."
  },
  {
    "title": "Irshalgad & Prabal Fort Treks",
    "description": "For moderate treks, Irshalgad’s iconic pinnacle and Prabal Fort’s ruins offer adventurous ridge hikes with rewarding panoramic views."
  },
  {
    "title": "Mount Barry & Kondana Caves",
    "description": "Mount Barry offers a gentle hilltop walk, while nearby Kondana has ancient Buddhist caves and seasonal cascades—ideal for a relaxed yet enriching excursion."
  },
  {
    "title": "Matheran Market & Eco‑Friendly Paths",
    "description": "Explore the charming bazaar, pick up local snacks and crafts, and traverse the eco‑cobbled paths by foot, horse, or hand-pulled rickshaw—vehicles aren’t allowed!"
  }
],

  "services": [
    {
      "name": "Pune to Matheran Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Matheran for a scenic and relaxing hill station journey. Travel comfortably with experienced chauffeurs, smooth suspension, and air-conditioned cabins as you head toward one of Maharashtra’s most peaceful, vehicle-free hill resorts."
    },
    {
      "name": "One Way Innova Crysta Pune Matheran",
      "description": "Choose our one-way Innova Crysta service from Pune to Matheran for a cost-effective and flexible journey. Ideal for travelers planning to stay overnight or continue their trip onward."
    },
    {
      "name": "Round Trip Innova Crysta Pune Matheran",
      "description": "Book a round trip Innova Crysta cab for your Pune to Matheran getaway. Enjoy the convenience of a dedicated vehicle for both legs of the trip and flexible return scheduling."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Matheran",
      "description": "Stay cool and relaxed during your trip with our fully air-conditioned Innova Crysta taxis. Enjoy a peaceful and refreshing ride even during hot and humid months."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Matheran",
      "description": "Our trained chauffeurs provide a comfortable, stress-free drive to Matheran, handling winding hill roads and traffic so you can simply sit back and enjoy the views."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Matheran",
      "description": "Enjoy full privacy and flexibility with our private Innova Crysta taxis, perfect for family or couples’ hill station travel to Matheran. No shared rides—just you and your comfort."
    },
    {
      "name": "Online Booking Innova Crysta Pune Matheran",
      "description": "Book your Pune to Matheran Innova Crysta cab in just a few clicks. Use our secure online system to check availability, pricing, and confirm your ride instantly."
    },
    {
      "name": "Matheran Hill Station Innova Crysta",
      "description": "Experience the charm of Matheran with our dedicated hill station cab service. Stop at scenic viewpoints, relax in the fresh air, and explore the car-free zone without transport worries."
    },
    {
      "name": "Family Trip Innova Crysta Pune Matheran",
      "description": "Travel with your family in comfort. Our Innova Crysta offers 6-7 spacious seats, ample luggage room, and smooth rides—ideal for kids, elderly passengers, and group outings."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Matheran",
      "description": "Enjoy plush seating, legroom, and quiet cabins in our Innova Crysta cabs. Designed for long-distance and hill drives, this vehicle makes your Matheran trip soothing and fatigue-free."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Matheran",
      "description": "Get premium travel at budget pricing. Our Pune to Matheran Innova Crysta taxi offers excellent comfort, safety, and reliability without breaking the bank."
    },
    {
      "name": "Weekend Trip Innova Crysta Matheran",
      "description": "Perfect for a weekend retreat, our Matheran cab service gives you the flexibility to leave Pune on your schedule and return when you’re refreshed—without transport stress."
    },
    {
      "name": "Reliable Innova Crysta Taxi Matheran",
      "description": "Depend on our punctual, professional drivers and well-maintained cabs for your Pune to Matheran trip. Reliability is our promise—on-time every time."
    },
    {
      "name": "Hill Resort Trip Innova Crysta",
      "description": "Whether it's a romantic escape or a family vacation, our Innova Crysta cabs are ideal for hill resort destinations like Matheran—offering smooth performance on winding roads."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Designed for long routes like Pune to Matheran, our Innova Crysta cabs offer ergonomic seating, powerful AC, and superior ride quality for your comfort and peace of mind."
    }
  ],
  "tableData": [
    ["Pune to Matheran Innova Crysta Cab Booking", "One Way Innova Crysta Pune Matheran"],
    ["Round Trip Innova Crysta Pune Matheran", "AC Innova Crysta Taxi Pune Matheran"],
    ["Chauffeur Driven Innova Crysta Pune Matheran", "Private Innova Crysta Taxi Pune Matheran"],
    ["Online Booking Innova Crysta Pune Matheran", "Matheran Hill Station Innova Crysta"],
    ["Family Trip Innova Crysta Pune Matheran", "Comfortable Innova Crysta Cab Pune Matheran"],
    ["Budget Innova Crysta Taxi Pune Matheran", "Weekend Trip Innova Crysta Matheran"],
    ["Reliable Innova Crysta Taxi Matheran", "Hill Resort Trip Innova Crysta"],
    ["Long Distance Innova Crysta Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab for Pune to Matheran Trips",
    "WhyChoosedescription": "Experience a comfortable and scenic journey from Pune to the serene hill station of Matheran with our premium Innova Crysta cab service. Ideal for families, friends, and nature enthusiasts seeking a hassle-free getaway."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Hill Station Travel",
    "WhyChoosedescription": "Our Innova Crysta offers ample legroom, reclining seats, and powerful air conditioning, ensuring a smooth and relaxing ride even on the winding roads leading to Matheran. Perfect for groups of up to 6–7 passengers."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Pune–Matheran route and local conditions, providing safe and timely travel. They can also assist with luggage handling and local tips for your hill station adventure."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "We prioritize hygiene and vehicle upkeep to ensure your journey is safe and comfortable. Every Innova Crysta is thoroughly cleaned and sanitized before your trip to Matheran."
  },
  {
    "WhyChooseheading": "Flexible Booking with Door-to-Door Pickup",
    "WhyChoosedescription": "Book your cab from anywhere in Pune with flexible pickup and drop locations. Whether it’s early morning or late evening, our service is tailored to fit your travel plans seamlessly."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "Our fares cover fuel, tolls, driver allowances, taxes, and parking fees, providing you with clear, upfront pricing and no hidden charges—perfect for budget-conscious travelers."
  },
  {
    "WhyChooseheading": "Ideal for Family Vacations, Weekend Getaways, and Nature Tours",
    "WhyChoosedescription": "Whether you’re planning a quiet retreat, adventure hiking, or sightseeing in Matheran, our Innova Crysta cab offers the comfort and convenience to make your trip memorable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to help with reservations, itinerary changes, and any travel queries, ensuring your Pune to Matheran trip is smooth and stress-free."
  }
]

























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Matheran?",
        answer: "You can book easily by calling Meghana Cab at +91 9075462128 or through our website for instant confirmation."
    },
    {
        question: "What is the distance and travel time from Pune to Matheran?",
        answer: "Matheran is about 125 km from Pune, and it takes approximately 3.5 to 4 hours to reach via road."
    },
    {
        question: "Is Innova Crysta suitable for a trip to Matheran?",
        answer: "Yes, the Innova Crysta offers a comfortable and spacious ride, perfect for hilly terrain and group or family travel."
    },
    {
        question: "Can the cab go directly to Matheran market area?",
        answer: "No, vehicles are not allowed beyond Dasturi Point in Matheran. The cab will drop you at the entry point, and from there, you can take a toy train, horse ride, or walk."
    },
    {
        question: "Is a round-trip cab booking available for Matheran?",
        answer: "Yes, we offer both one-way and round-trip packages to Matheran from Pune."
    },
    {
        question: "Are the drivers experienced with the Matheran route?",
        answer: "Yes, our drivers are familiar with the route and local conditions for a safe and comfortable ride."
    },
    {
        question: "What is included in the Pune to Matheran cab fare?",
        answer: "The fare includes fuel, tolls, and driver charges. Any parking or entry charges at Dasturi Point are additional."
    },
    {
        question: "Is the vehicle sanitized before every trip?",
        answer: "Yes, all our cabs are thoroughly cleaned and sanitized before each journey."
    },
    {
        question: "Can I request stops for meals or sightseeing en route?",
        answer: "Yes, meal and rest stops can be arranged as per your preference during the trip."
    },
    {
        question: "What payment options are available for booking?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Omkar Kadam',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for our Matheran trip. The ride was smooth, and the vehicle was spotless. Great service from Meghana Cab.”',
    },
    {
        name: 'Ms. Sneha Bhosale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very convenient and safe journey to Matheran. The driver was polite and professional. Would definitely book again!”',
    },
];









































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneToMatheranSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Matheran Innova Crysta Cab Booking",
  "description": "Book chauffeur-driven AC Innova Crysta taxi from Pune to Matheran hill station. Ideal for family trips, weekend getaways, and long-distance travel with comfortable, budget-friendly options and online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Hill Station Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Matheran"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-matheran-innova-crysta-cab"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Matheran Innova Crysta Cab Booking | Comfortable Hill Station Taxi</title>
  <meta
    name="description"
    content="Comfortable AC Innova Crysta taxi service from Pune to Matheran hill station. Book online for family trips, weekend getaways, and budget-friendly travel with chauffeur-driven cars."
  />
  <meta
    name="keywords"
    content="Pune to Matheran Innova Crysta Cab Booking, One Way Innova Crysta Pune Matheran, Round Trip Innova Crysta Pune Matheran, AC Innova Crysta Taxi Pune Matheran, Chauffeur Driven Innova Crysta Pune Matheran, Private Innova Crysta Taxi Pune Matheran, Online Booking Innova Crysta Pune Matheran, Matheran Hill Station Innova Crysta, Family Trip Innova Crysta Pune Matheran, Comfortable Innova Crysta Cab Pune Matheran, Budget Innova Crysta Taxi Pune Matheran, Weekend Trip Innova Crysta Matheran, Reliable Innova Crysta Taxi Matheran, Hill Resort Trip Innova Crysta, Long Distance Innova Crysta Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMatheranSchema)}
  </script>
</Helmet>
            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomathereinnova;